import OfferCoupons from './offer-coupons';

export default OfferCoupons;